import { View, Accordion, Disclosure, DisclosureTitle, DisclosurePanel, Flex, TextField, Heading, Divider, Button, Link, ActionButton } from '@adobe/react-spectrum';
import React, { useEffect, useRef, useState } from 'react';
import { ContactFormData } from '../AddNewPerson';
import { Check, ExclamationTriangle } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

// Separate component sections
export const NameSection: React.FC<{
  data: {
    prefix: string;
    name1: string;
    name2: string;
    name3: string;
    suffix: string;
  };
  onChange: (data: {
    prefix: string;
    name1: string;
    name2: string;
    name3: string;
    suffix: string;
  }) => void;
  validationErrors: any
  expandedSectionKey:any
  setExpandedSectionKey:(data:any)=>void;
  setValidationErrors : (data:any)=>void;
  fieldConfig:any
  validationStatus:any
  setValidationStatus:(data:any)=>void;
}> = ({ data, onChange,validationErrors,expandedSectionKey,setExpandedSectionKey,
  setValidationErrors,
  fieldConfig,
  validationStatus,
  setValidationStatus }) => {
  const [isConfirmEnabled, setIsConfirmEnabled] = useState(false);
  const [isSectionRequired,setIsSectionRequired] = useState(false);
        useEffect(() => {
            if((fieldConfig?.prefix?.required && data.prefix.trim() === '')
              ||(fieldConfig?.name1?.required && data.name1.trim() === '')
              ||(fieldConfig?.name3?.required && data.name3.trim() === '')
              ||(fieldConfig?.suffix?.required && data.suffix.trim() === '')
            ){
              setValidationStatus((prev:any) => ({ ...prev, ['nameSection']: false }));
              setIsSectionRequired(true)
            }else{
              setValidationStatus((prev:any) => ({ ...prev, ['nameSection']: true }));
            } 
            
          }, [fieldConfig]);
        // useEffect(() => {
        //   const checkRequiredFields = () => {
        //     if (!fieldConfig) return false;
        
        //     return Object.keys(fieldConfig).every((key) => {
        //       if (fieldConfig[key]?.required) {
        //         const value = data[key as keyof typeof data];
        //         return value && value.trim() !== '';
        //       }
        //       return true; // not required, so always valid
        //     });
        //   };
        
        //   setIsConfirmEnabled(checkRequiredFields());
        // }, [data, fieldConfig]);

  const inputRef = useRef<any>(null);
    useEffect(() => {
    if (expandedSectionKey?.has?.("nameSection")) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 200); 
    }
  }, [expandedSectionKey]);
  
  const handleSectionExpandedChange = () => {
    setExpandedSectionKey((prevKey:any) => prevKey.has("nameSection") ? new Set() : new Set(["nameSection"]));
  };
  const handleConfirm = ()=>{
    const errors:any = {};
    if(fieldConfig?.name1?.required && data.name1.trim() === ''){
      errors.name1 = 'Surname is required';
    }
    if(fieldConfig?.name3?.required && data.name3.trim() === ''){
      errors.name3 = 'First name is required';
    }
    if(fieldConfig?.prefix?.required && data.prefix.trim() === ''){
      errors.prefix = 'Prefix is required';
    }
    if(fieldConfig?.suffix?.required && data.suffix.trim() === ''){
      errors.suffix = 'Suffix is required';
    }
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      setValidationStatus((prev:any) => ({ ...prev, ['nameSection']: false }));
      return;
    }
    setValidationStatus((prev:any) => ({ ...prev, ['nameSection']: true }));
    setExpandedSectionKey(new Set(['addressSection']))
  }

  const validateRequiredFields = ()=>{
      const errors:any = {};
    if(fieldConfig?.name1?.required && data.name1.trim() === ''){
      errors.name1 = '';
    }
    if(fieldConfig?.name3?.required && data.name3.trim() === ''){
      errors.name3 = '';
    }
    if(fieldConfig?.prefix?.required && data.prefix.trim() === ''){
      errors.prefix = '';
    }
    if(fieldConfig?.suffix?.required && data.suffix.trim() === ''){
      errors.suffix = '';
    }
    if (Object.keys(errors).length > 0) {
      setValidationStatus((prev:any) => ({ ...prev, ['nameSection']: false }));
      return;
    }
    setValidationStatus((prev:any) => ({ ...prev, ['nameSection']: true }));
  }

  useEffect(()=>{
    validateRequiredFields();
  },[data])
  const { t } = useTranslation('contacts');
  const _t = (key: string) => t(`addNewPerson.${key}`, { ns: 'contacts' });
  const _tt = (key: string) => t(`contact_common.${key}`, { ns: 'contacts' });
  return (
    <Accordion expandedKeys={expandedSectionKey} isQuiet onExpandedChange={()=>handleSectionExpandedChange()}>
          <Disclosure id={"nameSection"}>
            <DisclosureTitle>
              <Flex justifyContent="space-between" alignItems="center" width="100%">
                <View><span>{_t(`name`)}</span><span style={{color:'#B0BEC5',fontFamily:'Adobe Clean'}}>{isSectionRequired && ` (${_tt('required')})`}</span></View>
                {validationStatus.nameSection ? <Check size={20} color="#1976D2" /> :<ExclamationTriangle size={20} color="#FF9800" />}
              </Flex>
            </DisclosureTitle>
            <DisclosurePanel>
            <Divider size='M' UNSAFE_style={{marginBottom:5}}/>
            <Flex direction={{base:"column",L:'row'}} gap="size-100" width="100%">
            <TextField
              label={_t("prefix")}
              ref={inputRef}
              aria-label={_t('prefix')}
              value={data.prefix}
              onChange={(prefix) => onChange({ ...data, prefix })}
              width="30%"
              isRequired={fieldConfig?.prefix?.required}
              errorMessage={fieldConfig?.prefix?.required && validationErrors.prefix}
              validationState={fieldConfig?.prefix?.required && validationErrors.prefix ? data.prefix === '' ? 'invalid' : 'valid' : undefined}
               />
            <TextField
              label={_t("first_name")}
              aria-label={_t('first_name')}
              value={data.name3}
              onChange={(name3) => {
                onChange({ ...data, name3 })
              }}
              isRequired={fieldConfig?.name3?.required}
              errorMessage={fieldConfig?.name3?.required && validationErrors.name3}
              validationState={fieldConfig?.name3?.required && validationErrors.name3 ? data.name3 === '' ? 'invalid' : 'valid' : undefined}
              width="100%" />
            <TextField
              label={_t("sur_name")}
              aria-label={_t('sur_name')}
              value={data.name1}
              onChange={(name1) => {
                onChange({ ...data, name1 })
              }}
              onBlur={()=>validateRequiredFields()}
              isRequired={fieldConfig?.name1?.required}
              errorMessage={fieldConfig?.name1?.required && validationErrors.name1}
              validationState={fieldConfig?.name1?.required && validationErrors.name1 ? data.name1 === '' ? 'invalid' : 'valid' : undefined}
              width="100%" />
            <TextField
              label={_t("suffix")}
              aria-label={_t('suffix')}
              value={data.suffix}
              onChange={(suffix) => onChange({ ...data, suffix })}
              onBlur={()=>validateRequiredFields()}
              width="30%"
              isRequired={fieldConfig?.suffix?.required}
              errorMessage={fieldConfig?.suffix?.required && validationErrors.suffix}
              validationState={fieldConfig?.suffix?.required && validationErrors.suffix ? data.suffix === '' ? 'invalid' : 'valid' : undefined} />
          </Flex>
          <Flex justifyContent={'end'} marginTop={10} gap={'size-50'}>
             <ActionButton onPress={handleConfirm} isQuiet UNSAFE_style={{color:'#1976D2',padding:10}}><Check size={22} color='#1976D2' /> {_tt('button_confirm')}</ActionButton> {/*active:#1976D2, disabled:#B0BEC5*/}
          </Flex>
          <Divider size='M' UNSAFE_style={{marginTop:10}} />
            </DisclosurePanel>
            </Disclosure>
    </Accordion>
);
}
